// src/components/features/Cart/Checkout.js
import React, { useContext, useState, useEffect, useRef } from "react";
import CartContext from "../../../context/CartContext";
import { BusinessContext } from "../../../context/BusinessContext";
import {
  HomeOutlined,
  EnvironmentOutlined,
  ShoppingOutlined,
  CreditCardOutlined,
  ArrowRightOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import {
  Button,
  Breadcrumb,
  Row,
  Col,
  Typography,
  Form,
  Input,
  Modal,
  Radio,
  Flex,
  Space,
  Divider,
  List,
  Spin,
  Empty,
  Skeleton,
  message,
  InputNumber,
  Popconfirm
} from "antd";

import { useNavigate } from "react-router-dom";
import "../../features/Cart/Checkout.css";
import "../../features/Cart/Cart.css";
import visacard from "../../../assets/images/visa.svg";
import americancard from "../../../assets/images/american-express.svg";
import mastercard from "../../../assets/images/mastercard.svg";
import payoneercard from "../../../assets/images/payoneer.svg";
import applepaycard from "../../../assets/images/applepay.svg";
import jcbcard from "../../../assets/images/jcb.svg";
import emptycart from "../../../assets/images/empty_cart.png";
import discovercard from "../../../assets/images/discover.svg";
import banktransfercard from "../../../assets/images/bank-transfer.svg";
import { initMap } from '../../../utils/initMap';
import { loadGoogleMapsScript } from "../../../utils/loadGoogleMapsScript";
import { useStripe, useElements, CardElement } from '@stripe/react-stripe-js';
import { StripePaymentSubmit, fetchUserAddress, fetchGuestUserAddress, AddGuestUserAddress, AddUserAddress, CheckDeliveryUserAddress, CheckDeliveryGuestAddress, OrderPaymentSubmit, deleteGuestUserAddress  } from '../../../utils/api';

const { TextArea } = Input;
const { Title, Link } = Typography;

const cardStyle = {
  style: {
    base: {
      color: '#32325d',
      fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
      fontSize: '16px',
      fontSmoothing: 'antialiased',
      '::placeholder': {
        color: '#aab7c4',
      },
    },
    invalid: {
      color: '#fa755a',
      iconColor: '#fa755a',
    },
  },
};

const Checkout = () => {
  const stripe = useStripe();
  const elements = useElements();
  
  const [error, setError] = useState(null);
  const [processing, setProcessing] = useState(false);
  const [paymentMethod, setPaymentMethod] = useState("credit");
  const navigate = useNavigate();
  const [Addressform] = Form.useForm();
  const [Collectionform] = Form.useForm();
  const [userLoggedIn, setUserLoggedIn] = useState(false);
  const [userId, setUserId] = useState(null);
  const [addressID, setaddressID] = useState(null);
  const [userLoggedAddresses, setUserLoggedAddresses] = useState([]);
  const [userGuestAddresses, setUserGuestAddresses] = useState([]);
  const [orderby, setorderby] = useState(0);
  const [selectedDeliveryAddress, setSelectedDeliveryAddress] = useState(null);
  const [deliveryCharge, setDeliveryCharge] = useState(0);
  const [isLoggedAddressModalVisible, setIsLoggedAddressModalVisible] = useState(false);
  const [isGuestLoggedAddressModalVisible, setIsGuestLoggedAddressModalVisible] = useState(false);
  const [showCollectionInfoForm, setShowCollectionInfoForm] = useState(false);
  const [mapLoaded, setMapLoaded] = useState(false);
  const [currentOrderType, setCurrentOrderType] = useState(null);
  const [userContactInfo, setUserContactInfo] = useState({
    full_name: "",
    mobile_number: "",
    email: ""
  });
  
  const updateMapData = (address, lat, lng, zipCode, houseNumberAndStreet, locality, country) => {
    Addressform.setFieldsValue({
      full_address: address ?? '',
      latitude: lat ?? '',
      longitude: lng ?? '',
      zipcode: zipCode ?? '',
      house_number_street: houseNumberAndStreet ?? '',
      locality: locality ?? '',
      country: country ?? '',
    });
  };

  // Show modal
  const showLoggedAddressModal = () => {
    setIsLoggedAddressModalVisible(true);
    // Load map when modal opens
    setTimeout(() => {
      if (!mapLoaded) {
        loadGoogleMapsScript(() => {
          initMap(updateMapData);
          setMapLoaded(true);
        });
      } else {
        // Reinitialize map if already loaded
        setTimeout(() => initMap(updateMapData), 100);
      }
    }, 300);
  };

  // Hide modal
  const handleLoggedAddressCancel = () => {
    setIsLoggedAddressModalVisible(false);
  };

  const showGuestLoggedAddressModal = () => {
    setIsGuestLoggedAddressModalVisible(true);
    // Load map when modal opens
    setTimeout(() => {
      if (!mapLoaded) {
        loadGoogleMapsScript(() => {
          initMap(updateMapData);
          setMapLoaded(true);
        });
      } else {
        // Reinitialize map if already loaded
        setTimeout(() => initMap(updateMapData), 100);
      }
    }, 300);
  };

  // Hide modal
  const handleGuestLoggedAddressCancel = () => {
    setIsGuestLoggedAddressModalVisible(false);
  };

  const handleShowCollectionInfoForm = () => {
    setShowCollectionInfoForm(true);
  };
  
  const [driverTips, setDriverTips] = useState(0);
  const [specialComment, setSpecialComment] = useState("");
  const [CouponCode, setCouponCode] = useState("");
  const { businessInfo, loading } = useContext(BusinessContext);
  const { cart, updateItem, updateOrderType, cookiesId, ApplyCouponCode } = useContext(CartContext);
  
  // Get order type from cart with proper fallback
  const orderType = cart?.Carts?.order_type ?? 0;
  const comparisionDiscount = cart?.Carts?.ComparisonRate ?? 0;
  const dis_type = cart?.Carts?.dis_type;
  const dis_amount = cart?.Carts?.dis_amount;
  const [Cartloading, setCartLoading] = useState(false);

  // Track order type changes
  useEffect(() => {
    if (cart?.Carts?.order_type !== undefined) {
      setCurrentOrderType(cart.Carts.order_type);
      
      // Reset states when order type changes
      if (cart.Carts.order_type === 1) { // Collection
        setShowCollectionInfoForm(!userLoggedIn);
        if (userLoggedIn) {
          setSelectedDeliveryAddress("collection");
        }
      } else { // Delivery
        setShowCollectionInfoForm(false);
        // Don't reset selectedDeliveryAddress for delivery to maintain selection
      }
    }
  }, [cart?.Carts?.order_type, userLoggedIn]);

  useEffect(() => {
    console.log("=== Stripe Debug Info ===");
    console.log("Stripe loaded:", !!stripe);
    console.log("Elements loaded:", !!elements);
    console.log("Payment method:", paymentMethod);
  }, [stripe, elements, paymentMethod]);

  const handlePaymentMethodChange = (e) => {
    setPaymentMethod(e.target.value);
  };
  
  const handleDriverTipChange = (value) => {
    setDriverTips(value);
  };
  
  const handleSpecialCommentChange = (e) => {
    setSpecialComment(e.target.value);
  };

  const handleCouponCodeChange = (e) => {
    setCouponCode(e.target.value);
  };

  const handleUpdateItem = async (itemId, newQuantity) => {
    setCartLoading(true);
    try {
      await updateItem(itemId, newQuantity);
    } catch (error) {
      console.error("Failed to update item:", error);
    } finally {
      setCartLoading(false);
    }
  };
  
  const handleUpdateOrderType = async (order_type) => {
    setCartLoading(true);
    try {
      await updateOrderType(order_type);
    } catch (error) {
      console.error("Failed to update order type:", error);
    } finally {
      setCartLoading(false);
    }
  };

  const CustomEmpty = () => (
    <Empty
      image={emptycart}
      imageStyle={{
        height: 80,
      }}
      description={
        <div>
          <h2>Your Cart is Empty!</h2>
          <p>Must add items to the cart before you proceed to checkout.</p>
        </div>
      }
    />
  );

  const handleDeliveryAddressChange = async (e) => {
    try {
      const formData = {
        cookie_id: cookiesId,
        address_id: e.target.value 
      };
      setaddressID(e.target.value);
      let response; 
      if (localStorage.getItem('userId')) {
        response = await CheckDeliveryUserAddress(formData);
      } else {
        response = await CheckDeliveryGuestAddress(formData);
      }
      if (response && response.status === "success") {
        setSelectedDeliveryAddress(e.target.value); 
        setDeliveryCharge(parseFloat(response.data));  
        message.success({
          content: response.message || "Delivery charge fetched successfully.",
          duration: 5, 
        });
      } else {
        setSelectedDeliveryAddress("");  
        setDeliveryCharge("");  
        message.error({
          content: response.message || "Failed to fetch delivery charge. Please try again.",
          duration: 5, 
        });
      }
    } catch (error) {
      setSelectedDeliveryAddress("");  
      setDeliveryCharge("");  
      console.error("Error:", error);  
      message.error({
        content: "An unexpected error occurred. Please try again later.",
        duration: 5, 
      });
    }
  };

  // Fix the useEffect for payment methods
  const portalInfo = businessInfo?.businessInfo?.[0]?.portal_info?.[0];

  useEffect(() => {
    if (!portalInfo) return;
    
    console.log("Portal info:", portalInfo);
    
    // Delivery orders
    if (orderType === 0) {
      const cardEnabled = portalInfo.delivery_card_enable === 0;
      const cashEnabled = portalInfo.delivery_cash_enable === 0;
      
      console.log("Delivery - Card enabled:", cardEnabled, "Cash enabled:", cashEnabled);
      
      if (cardEnabled && cashEnabled) {
        if (!paymentMethod) setPaymentMethod("credit");
      } else if (cardEnabled) {
        setPaymentMethod("credit");
      } else if (cashEnabled) {
        setPaymentMethod("cash");
      }
    }
    // Pickup orders
    else if (orderType === 1) {
      const cardEnabled = portalInfo.pickup_card_enable === 0;
      const cashEnabled = portalInfo.pickup_cash_enable === 0;
      
      console.log("Pickup - Card enabled:", cardEnabled, "Cash enabled:", cashEnabled);
      
      if (cardEnabled && cashEnabled) {
        if (!paymentMethod) setPaymentMethod("credit");
      } else if (cardEnabled) {
        setPaymentMethod("credit");
      } else if (cashEnabled) {
        setPaymentMethod("cash");
      }
    }
  }, [portalInfo, orderType, paymentMethod]);
  
  // ✅ Base price of item (checks master_size first)
  const getItemBasePrice = (item) => {
    if (item?.master_size) {
      return Number(item.master_size.delivery_item_price || 0);
    }
    return Number(item.delivery_item_price || 0);
  };

  // ✅ Addons calculation
  const getAddonPrice = (item) => {
    if (!item?.extra_addons || item.extra_addons.length === 0) return 0;
    return item.extra_addons.reduce(
      (sum, addon) => sum + addon.addon_price * addon.quantity,
      0
    );
  };

  // ✅ Item total = base + addons * quantity
  const getItemTotal = (item) => {
    const basePrice = getItemBasePrice(item);
    const addonPrice = getAddonPrice(item);
    return (basePrice + addonPrice) * item.quantity;
  };

  // ✅ Subtotal (only one definition, using getItemTotal)
  const subtotal = cart?.data?.reduce((total, item) => total + getItemTotal(item), 0) || 0;

  // ✅ Delivery Charge
  let calculatedDeliveryCharge = 0;
  if (businessInfo?.businessInfo?.[0]?.portal_info?.[0]?.delivery_type_enable === 0) {
    const freeDeliveryThreshold =
      businessInfo?.businessInfo?.[0]?.charge_info?.[0]?.free_delivery_above_subTotal;
    const defaultDeliveryCharge =
      businessInfo?.businessInfo?.[0]?.charge_info?.[0]?.default_delivery_charge ?? 0;

    if (freeDeliveryThreshold && subtotal < freeDeliveryThreshold) {
      calculatedDeliveryCharge = Number(defaultDeliveryCharge);
    } else {
      calculatedDeliveryCharge = Number(defaultDeliveryCharge);
    }
  }

  // ✅ Packaging Fee
  let packageFee = 0;
  if (businessInfo?.businessInfo?.[0]?.charge_info?.[0]?.packaging_charge_enable === 1) {
    packageFee = Number(businessInfo?.businessInfo?.[0]?.charge_info?.[0]?.packaging_charge ?? 0);
  }

  // ✅ Discounts
  const discountRate = businessInfo?.businessInfo?.[0]?.pdq2_agreed_discount / 100 || 0;
  const discount = subtotal * discountRate;
  const totalComparisonDiscount = subtotal * comparisionDiscount;

  // ✅ Coupon Discount
  let couponDiscount = 0;
  if (dis_type && dis_amount) {
    if (dis_type === "1") {
      couponDiscount = subtotal * (dis_amount / 100); // Percentage
    } else if (dis_type === "0") {
      couponDiscount = parseFloat(dis_amount); // Fixed
    }
  }

  // ✅ Grand Total
  let grandTotal;
  if (orderType === 0) {
    grandTotal = subtotal + calculatedDeliveryCharge + packageFee + driverTips - (discount + couponDiscount);
  } else {
    grandTotal = subtotal + packageFee - (discount + couponDiscount);
  }

  // ✅ Total Savings
  const totalSavings = discount + totalComparisonDiscount + couponDiscount;

  const fetchLoggedAddress = async (userId) => {
    if (!userId) {
      console.error("User ID is required to fetch addresses.");
      return;
    }
    const loggedAddresses = await fetchUserAddress(userId);
    if (loggedAddresses) {
      setUserLoggedAddresses(loggedAddresses.data);
      // Auto-select the first address if available for delivery
      if (loggedAddresses.data.length > 0 && orderType === 0 && !selectedDeliveryAddress) {
        const firstAddress = loggedAddresses.data[0];
        setSelectedDeliveryAddress(firstAddress.id);
        setaddressID(firstAddress.id);
        // Fetch delivery charge for the first address
        handleDeliveryAddressChange({ target: { value: firstAddress.id } });
      }
    }
  };

  const GuestUserAddress = async (cookiesId) => {
    if (!cookiesId) {
      console.error("cookiesId is required to fetch addresses.");
      return;
    }
    try {
      const guestAddresses = await fetchGuestUserAddress(cookiesId);
      if (guestAddresses && guestAddresses.data) {
        setUserGuestAddresses(guestAddresses.data);
        // Auto-select the first address if available for delivery
        if (guestAddresses.data.length > 0 && orderType === 0 && !selectedDeliveryAddress) {
          const firstAddress = guestAddresses.data[0];
          setSelectedDeliveryAddress(firstAddress.id);
          setaddressID(firstAddress.id);
          // Fetch delivery charge for the first address
          handleDeliveryAddressChange({ target: { value: firstAddress.id } });
        }
        
        // If no addresses and delivery order, load map
        if (guestAddresses.data.length === 0 && orderType === 0 && !mapLoaded) {
          setTimeout(() => {
            loadGoogleMapsScript(() => {
              initMap(updateMapData);
              setMapLoaded(true);
            });
          }, 300);
        }
      } else {
        console.error("No addresses found or invalid data format.");
        // If no addresses and delivery order, load map
        if (orderType === 0 && !mapLoaded) {
          setTimeout(() => {
            loadGoogleMapsScript(() => {
              initMap(updateMapData);
              setMapLoaded(true);
            });
          }, 300);
        }
      }
    } catch (error) {
      console.error("Error fetching guest user addresses:", error);
      // If error and delivery order, load map
      if (orderType === 0 && !mapLoaded) {
        setTimeout(() => {
          loadGoogleMapsScript(() => {
            initMap(updateMapData);
            setMapLoaded(true);
          });
        }, 300);
      }
    }
  };

  useEffect(() => {
    const token = localStorage.getItem('authToken');
    const userIdFromStorage = localStorage.getItem('userId') || '';
    setUserId(userIdFromStorage);
    if (token && userIdFromStorage) {
      setUserLoggedIn(true);
      setorderby(1);
      setUserId(userIdFromStorage);
      fetchLoggedAddress(userIdFromStorage);
      
      // Auto-set collection for logged-in users
      if (orderType === 1 && !selectedDeliveryAddress) {
        setSelectedDeliveryAddress("collection");
      }
      
      if (isLoggedAddressModalVisible) {
        setTimeout(() => {
          if (!mapLoaded) {
            loadGoogleMapsScript(() => {
              initMap(updateMapData);
              setMapLoaded(true);
            });
          }
        }, 300);
      }
    } else {
      setorderby(0);
      setUserLoggedIn(false);
      GuestUserAddress(cookiesId);
      
      // Show collection form for guest users
      if (orderType === 1 && !selectedDeliveryAddress) {
        setShowCollectionInfoForm(true);
      }
      
      if (isGuestLoggedAddressModalVisible) {
        setTimeout(() => {
          if (!mapLoaded) {
            loadGoogleMapsScript(() => {
              initMap(updateMapData);
              setMapLoaded(true);
            });
          }
        }, 300);
      }
    }
  }, [isLoggedAddressModalVisible, cookiesId, isGuestLoggedAddressModalVisible, orderType]);

  // Load map when order type changes to delivery and no addresses exist
  useEffect(() => {
    if (orderType === 0) {
      if (userLoggedIn) {
        // For logged-in users, show map if no addresses exist
        if (userLoggedAddresses.length === 0 && !mapLoaded) {
          loadGoogleMapsScript(() => {
            initMap(updateMapData);
            setMapLoaded(true);
          });
        }
      } else {
        // For guest users, show map if no addresses exist
        if (userGuestAddresses.length === 0 && !mapLoaded) {
          loadGoogleMapsScript(() => {
            initMap(updateMapData);
            setMapLoaded(true);
          });
        }
      }
    }
  }, [orderType, userLoggedIn, userLoggedAddresses.length, userGuestAddresses.length, mapLoaded]);

  const handleUserAddressSubmit = async (values) => {
    try {
      const formData = {
        cookie_id: cookiesId,
        user_id: userId,
        full_address: values.full_address,
        mobile_number: values.mobile_number,
        latitude: values.latitude,
        longitude: values.longitude,
        locality: values.locality,
        house_number_street: values.house_number_street,
        town_city_name: values.town_city_name,
        country: values.country,
        zipcode: values.zipcode,
        address_label: values.address_label,
      };
      const response = await AddUserAddress(formData);
    
      if (response && response.status === "success" && response.status_code === 200) {
        setIsLoggedAddressModalVisible(false);
        fetchLoggedAddress(userId);
        message.success({
          content: response.message || "Your address has been added successfully.",
          duration: 5,
        });
      } else {
        message.error({
          content: response.message || "Failed to add the address. Please try again.",
          duration: 5,
        });
      }
    } catch (error) {
      message.error({
        content: "An unexpected error occurred. Please try again later.",
        duration: 5,
      });
    }
  };

  const handleGuestAddressSubmit = async (values) => {
    try {
      const formData = {
        cookie_id: cookiesId,
        full_address: values.full_address,
        full_name: values.full_name,
        mobile_number: values.mobile_number,
        email: values.email,
        latitude: values.latitude,
        longitude: values.longitude,
        locality: values.locality,
        house_number_street: values.house_number_street,
        town_city_name: values.town_city_name,
        country: values.country,
        zipcode: values.zipcode,
      };
      const response = await AddGuestUserAddress(formData);
      if (response && response.success === "success" && response.status_code === 200) {
        if (isGuestLoggedAddressModalVisible) {
          setIsGuestLoggedAddressModalVisible(false);
        }
        GuestUserAddress(cookiesId);
        message.success({
          content: "Your address has been added successfully.",
          duration: 5,
        });
      } else {
        message.error({
          content: response.message || "Failed to add the address. Please try again.",
          duration: 5,
        });
      }
    } catch (error) {
      message.error({
        content: "An unexpected error occurred. Please try again later.",
        duration: 5,
      });
    }
  };

  // Handle collection info submission for guest users
  const handleCollectionInfoSubmit = async (values) => {
    try {
      setUserContactInfo({
        full_name: values.full_name,
        mobile_number: values.mobile_number,
        email: values.email
      });
      setSelectedDeliveryAddress("collection");
      setShowCollectionInfoForm(false);
      
      message.success({
        content: "Your information has been saved.",
        duration: 3,
      });
    } catch (error) {
      message.error({
        content: "An unexpected error occurred. Please try again later.",
        duration: 5,
      });
    }
  };

  const handleGuestAddressDelete = async (addressId) => {
    const response = await deleteGuestUserAddress(addressId);
    if (response && response.status === "success") {
      await GuestUserAddress(cookiesId);
      
      // If no addresses left and order type is delivery, load map
      if (userGuestAddresses.length <= 1 && orderType === 0) {
        setTimeout(() => {
          loadGoogleMapsScript(() => {
            initMap(updateMapData);
            setMapLoaded(true);
          });
        }, 500);
      }
      
      message.success({
        content: response.message || "Address deleted successfully.",
        duration: 5, 
      });
    } else {
      message.error({
        content: "An unexpected error occurred. Please try again later.",
        duration: 5, 
      });
    }
  };  

  const handleCouponCode = async () => {
    setCartLoading(true);
    try {
      const formData = {
        cookie_id: cookiesId,
        user_id: userId,
        subtotal: subtotal,
        orderType: orderType,
        couponCode: CouponCode
      };
      const response = await ApplyCouponCode(formData);
      if (response && response.success) {
        message.success({
          content: "The coupon code has been successfully applied.",
          duration: 5,
        });
        setCartLoading(false);
      } else {
        message.error({
          content: response.message || "Invalid Coupon Code.",
          duration: 5,
        });
        setCartLoading(false);
      }
    } catch (error) {
      message.error({
        content: "Invalid Coupon Code.",
        duration: 5,
      });
      setCartLoading(false);
    }
  };

  // Get user contact information for order submission
  const getUserContactInfo = () => {
    let contactInfo = {
      user_id: userId ?? "",
      full_name: "",
      mobile_number: "",
      email: ""
    };

    // For collection orders (both logged-in and guest users)
    if (orderType === 1 && selectedDeliveryAddress === "collection") {
      if (userLoggedIn) {
        // For logged-in users with collection, get from user context or use defaults
        contactInfo = {
          user_id: userId ?? "",
          full_name: "User", // You should replace this with actual user data from context
          mobile_number: "", // You should replace this with actual user data from context  
          email: "" // You should replace this with actual user data from context
        };
      } else {
        // For guest users with collection, get from saved state
        contactInfo = {
          user_id: userId ?? "",
          full_name: userContactInfo.full_name || "",
          mobile_number: userContactInfo.mobile_number || "",
          email: userContactInfo.email || ""
        };
      }
    }
    // For delivery orders - guest users
    else if (!userLoggedIn && orderType === 0 && selectedDeliveryAddress) {
      const selectedAddress = userGuestAddresses.find(addr => addr.id === selectedDeliveryAddress);
      if (selectedAddress) {
        contactInfo = {
          user_id: userId ?? "",
          full_name: selectedAddress.full_name || "",
          mobile_number: selectedAddress.mobile_number || "",
          email: selectedAddress.email || ""
        };
      }
    }
    // For delivery orders - logged-in users
    else if (userLoggedIn && orderType === 0 && selectedDeliveryAddress) {
      const selectedAddress = userLoggedAddresses.find(addr => addr.id === selectedDeliveryAddress);
      if (selectedAddress) {
        contactInfo = {
          user_id: userId ?? "",
          full_name: selectedAddress.address_label || "User",
          mobile_number: selectedAddress.mobile_number || "",
          email: "" // Get from user context if available
        };
      }
    }

    return contactInfo;
  };

  // FIXED STRIPE PAYMENT HANDLER
  const handleStripePayment = async () => {
    try {
      const cardElement = elements.getElement(CardElement);
      if (!cardElement) {
        throw new Error("Card information is required.");
      }

      console.log("Creating Stripe payment method...");
      
      // Create Payment Method
      const { paymentMethod: stripePaymentMethod, error: pmError } = await stripe.createPaymentMethod({
        type: 'card',
        card: cardElement,
        billing_details: {
          name: getUserContactInfo().full_name || 'Customer',
          email: getUserContactInfo().email || '',
          phone: getUserContactInfo().mobile_number || '',
        },
      });

      if (pmError) {
        console.error("Payment Method creation error:", pmError);
        throw pmError;
      }

      console.log("Payment Method created:", stripePaymentMethod.id);

      // Get user contact information
      const userContactInfo = getUserContactInfo();

      // Prepare data for backend - MATCHING YOUR BACKEND EXPECTATIONS
      const stripeData = {
      amount: grandTotal, // Convert to pence
      payment_method: stripePaymentMethod.id, 
      return_url: `${window.location.origin}/thank-you`,
      order_type: orderType,
      user_id: userContactInfo.user_id || 'guest',
      metadata: {
        order_type: orderType,
        user_id: userContactInfo.user_id || 'guest',
        timestamp: new Date().toISOString(),
      }
    };
      console.log("Sending to backend API:", stripeData);

      // Call backend to create PaymentIntent
      const stripeResponse = await StripePaymentSubmit(stripeData);

      console.log("Backend Stripe response:", stripeResponse);

      if (!stripeResponse) {
        throw new Error("No response from payment server.");
      }

      // Handle different response statuses
      if (stripeResponse.status === "requires_action" && stripeResponse.client_secret) {
        // Handle 3D Secure or other authentication
        console.log("Requires 3D Secure authentication...");
        
        const { error: confirmError, paymentIntent } = await stripe.confirmCardPayment(
          stripeResponse.client_secret,
          {
            payment_method: stripePaymentMethod.id,
          }
        );

        if (confirmError) {
          console.error("3D Secure confirmation error:", confirmError);
          throw confirmError;
        }

        console.log("Payment confirmed:", paymentIntent);
        
        if (paymentIntent.status === 'succeeded') {
          return {
            success: true,
            payment_intent_id: paymentIntent.id,
            stripe_payment_status: 'succeeded'
          };
        } else {
          throw new Error(`Payment status: ${paymentIntent.status}`);
        }
      } 
      else if (stripeResponse.status === "success") {
        // Payment succeeded immediately
        return {
          success: true,
          payment_intent_id: stripeResponse.payment_intent_id,
          stripe_payment_status: 'succeeded'
        };
      }
      else if (stripeResponse.status === "processing") {
        // Payment is processing
        return {
          success: true,
          payment_intent_id: stripeResponse.payment_intent_id,
          stripe_payment_status: 'processing'
        };
      }
      else {
        // Error from backend
        throw new Error(stripeResponse.message || "Payment processing failed");
      }
    } catch (err) {
      console.error("Stripe payment error:", err);
      throw err;
    }
  };

  // Function to complete order after successful payment
  const completeOrder = async (paymentResult) => {
    const userContactInfo = getUserContactInfo();
    
    const orderData = {
      cookie_id: cookiesId ?? "",
      orderby,
      user_id: userContactInfo.user_id,
      full_name: userContactInfo.full_name,
      mobile_number: userContactInfo.mobile_number,
      email: userContactInfo.email,
      subtotal: subtotal ?? "0",
      orderType: orderType ?? "",
      discountRate: discountRate ?? "0",
      discount: discount ?? "0",
      comparisionDiscount: comparisionDiscount ?? "0",
      TotalComparisonDiscount: totalComparisonDiscount ?? "0",
      coupon_discount: couponDiscount ?? "0",
      deliveryCharge: calculatedDeliveryCharge ?? "0",
      PackageFee: packageFee ?? "0",
      driverTips: driverTips ?? "0",
      grandTotal: grandTotal ?? "0",
      totalSavings: totalSavings ?? "0",
      paymentMethod: paymentMethod ?? "",
      address_id: addressID ?? "",
      payment_status: "1", // Paid
      instructions: specialComment ?? "",
      offer_discount: "0",
      voucher_discount: "0",
      stripe_payment_status: paymentResult.stripe_payment_status,
      stripe_transaction_id: paymentResult.payment_intent_id,
      stripe_created_at: new Date().toISOString(),
    };

    console.log("Submitting order:", orderData);

    const orderResponse = await OrderPaymentSubmit(orderData);

    if (orderResponse && orderResponse.status === "success" && orderResponse.status_code === 200) {
      const orderId = orderResponse.orderId;
      message.success("Payment successful. Your order has been placed.");
      
      // Redirect to thank you page
      navigate(`/thank-you/${orderId}`);
      return true;
    } else {
      throw new Error(
        orderResponse?.message ||
        "An error occurred while placing your order."
      );
    }
  };

  // FIXED MAIN HANDLE PLACE ORDER FUNCTION
  const handlePlaceOrder = async (e) => {
    e.preventDefault();

    console.log("=== STRIPE DEBUG ===");
    console.log("Stripe instance:", !!stripe);
    console.log("Elements instance:", !!elements);
    console.log("Payment method:", paymentMethod);

    // Validate collection orders have required info
    if (orderType === 1 && selectedDeliveryAddress === "collection") {
      const contactInfo = getUserContactInfo();
      if (!contactInfo.full_name || !contactInfo.mobile_number || !contactInfo.email) {
        message.error("Please provide your full name, mobile number, and email address for collection orders.");
        return;
      }
    }

    // For guest users with collection order type, check if info is filled
    if (!userLoggedIn && orderType === 1 && !selectedDeliveryAddress) {
      message.error("Please provide your contact information before placing the order.");
      return;
    }

    // Validate delivery address is selected for delivery orders
    if (orderType === 0 && !selectedDeliveryAddress) {
      message.error("Please select a delivery address before placing the order.");
      return;
    }

    // Validate minimum order amount
    const minDeliveryOrder = businessInfo?.businessInfo?.[0]?.charge_info?.[0]?.min_delivery_order || 0;
    const minPickupOrder = businessInfo?.businessInfo?.[0]?.charge_info?.[0]?.min_pickup_order || 0;
    
    if (orderType === 0 && subtotal < minDeliveryOrder) {
      message.error(`Minimum delivery order amount is £${minDeliveryOrder}`);
      return;
    }

    if (orderType === 1 && subtotal < minPickupOrder) {
      message.error(`Minimum pickup order amount is £${minPickupOrder}`);
      return;
    }

    if (paymentMethod === "credit" && (!stripe || !elements)) {
      message.error("Payment system not ready. Please try again.");
      return;
    }

    setProcessing(true);
    setError(null);

    try {
      if (paymentMethod === "credit") {
        console.log("Processing Stripe payment...");
        
        // Process Stripe payment
        const paymentResult = await handleStripePayment();
        
        if (!paymentResult.success) {
          throw new Error("Payment failed");
        }
        
        // Complete order with payment result
        await completeOrder(paymentResult);
        
      } else {
        // Handle cash payment
        await handleCashPayment();
      }
    } catch (err) {
      console.error("Order placement error:", err);
      message.error(err.message || "An unexpected error occurred.");
      setError(err.message);
    } finally {
      setProcessing(false);
    }
  };
  
  const handleCashPayment = async () => {
    setCartLoading(true);
    setProcessing(true);
    try {
      // Get user contact information
      const userContactInfo = getUserContactInfo();

      // Prepare the order data with user contact information
      const OrderformData = {
        cookie_id: cookiesId ?? '', 
        orderby: orderby, 
        user_id: userContactInfo.user_id,
        full_name: userContactInfo.full_name,
        mobile_number: userContactInfo.mobile_number,
        email: userContactInfo.email,
        subtotal: subtotal ?? '0', 
        orderType: orderType ?? '', 
        discountRate: discountRate ?? '0', 
        discount: discount ?? '0', 
        comparisionDiscount: comparisionDiscount ?? '0', 
        TotalComparisonDiscount: totalComparisonDiscount ?? '0', 
        coupon_discount: couponDiscount ?? '0', 
        deliveryCharge: calculatedDeliveryCharge ?? '0', 
        PackageFee: packageFee ?? '0', 
        driverTips: driverTips ?? '0', 
        grandTotal: grandTotal ?? '0', 
        totalSavings: totalSavings ?? '0', 
        paymentMethod: paymentMethod ?? '', 
        address_id: addressID ?? '', 
        payment_status:'0',
        instructions: specialComment ?? '',
        offer_discount: '0',
        voucher_discount: '0',
      };
      
      // Call the API for order submission
      const response = await OrderPaymentSubmit(OrderformData);
      
      // Check if the response is successful
      if (response && response.status === "success" && response.status_code === 200) {
        const orderId = response.orderId; 
        navigate(`/thank-you/${orderId}`);
        message.success({
          content: "Order placed successfully. Please prepare cash for payment.",
          duration: 5,
        });
      } else {
        message.error({
          content: response.message || "An error occurred while processing the order.",
          duration: 5,
        });
      }
    } catch (error) {
      console.error("Cash payment error:", error);
      message.error({
        content: error.message || "There was a problem placing the order. Please try again.",
        duration: 5,
      });
    } finally {
      setCartLoading(false);
      setProcessing(false);
    }
  };

  // Check if we can proceed to payment
  const canProceedToPayment = () => {
    if (orderType === 0) {
      return selectedDeliveryAddress !== null;
    } else {
      return selectedDeliveryAddress === "collection";
    }
  };

  // Render the appropriate content based on order type and user status
  const renderOrderTypeContent = () => {
    if (!cart?.data || cart.data.length === 0) return null;

    // For Delivery orders
    if (orderType === 0) {
      if (userLoggedIn) {
        // Logged in user - Delivery
        return (
          <>
            <div className="deliveryAddressSection commonSection">
              <div className="checkoutSectionMainWrap">
                <div className="checkoutRightWrap">
                  <Title level={3} className="customHeading">
                    Choose Delivery Address
                  </Title>
                  
                  <div className="addAddressWrap" onClick={showLoggedAddressModal}>
                    <svg width="24px" height="24px" viewBox="0 0 24 24" fill="#009de0">
                      <path d="M12 0C5.383 0 0 5.383 0 12s5.383 12 12 12 12-5.383 12-12S18.617 0 12 0zm5.25 13H13v4.25c0 .552-.448 1-1 1s-1-.448-1-1V13H6.75c-.552 0-1-.448-1-1s.448-1 1-1H11V6.75c0-.552.448-1 1-1s1 .448 1 1V11h4.25c.552 0 1 .448 1 1s-.448 1-1 1z"></path>
                    </svg>
                    Add New Address
                  </div>
                  
                  {/* User's Address List for Delivery */}
                  {userLoggedAddresses.length > 0 && (
                    <div className="checklistAddressList">
                      <Radio.Group
                        onChange={handleDeliveryAddressChange}
                        value={selectedDeliveryAddress}
                        className="addressRadioList"
                      >
                        <Row gutter={[8, 8]}>
                          {userLoggedAddresses.map((address, index) => (
                            <Col xs={24} sm={12} key={address.id}>
                              <Radio key={address.id} value={address.id}>
                                <div className="addressWrap">
                                  <div className="addressDetails">
                                    <h5>
                                      <HomeOutlined />
                                      {address.address_label}
                                    </h5>
                                    <p>{address.combine_address}</p>
                                  </div>
                                </div>
                              </Radio>
                            </Col>
                          ))}
                        </Row>
                      </Radio.Group>
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* Address Modal for Logged Users */}
            <Modal
              title="Add New Address"
              visible={isLoggedAddressModalVisible}
              onCancel={handleLoggedAddressCancel}
              maskClosable={false}
              footer={null}
            >
              {/* Map Viewer Start Here  */}
              <div style={{ position: "relative", height: "350px", width: "100%", marginBottom: "10px" }}>
                <input id="pac-input" className="controls" type="text" placeholder="Search for places" />
                <div id="map" style={{ height: "350px", width: "100%" }}></div>
              </div>
              {/*  Map Viewer End Here */}
              <Form layout="vertical" className="checkoutForm" form={Addressform} onFinish={handleUserAddressSubmit}>
                <ul id="addresses" style={{ display: "none" }}></ul>
                <Form.Item name="latitude" hidden><Input /></Form.Item>
                <Form.Item name="longitude" hidden><Input /></Form.Item>
                <Form.Item name="country" hidden><Input /></Form.Item>
                
                <Row gutter={16}>
                  <Col span={12} style={{ display: "none" }}>
                    <Form.Item
                      name="full_address"
                      label="Full Address"
                      rules={[{ required: true, message: "Please enter your Full Address!" }]}
                    >
                      <Input placeholder="Full Address" id="google_full_address" />
                    </Form.Item>
                  </Col>

                  <Col span={12}>
                    <Form.Item
                      label="House Number and Street"
                      name="house_number_street"
                      rules={[{ required: true, message: "Please enter your House Number and Street!" }]}
                    >
                      <Input placeholder="House Number and Street" id="house-number-street" />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      label="Town/City"
                      name="locality"
                      rules={[{ required: true, message: "Please enter your Town/City!" }]}
                    >
                      <Input placeholder="Town/City" id="locality" />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      label="Post Code"
                      name="zipcode"
                      rules={[{ required: true, message: "Please enter your Post Code!" }]}
                    >
                      <Input placeholder="Post Code" id="zipcode" />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      label="Mobile Number"
                      name="mobile_number"
                      rules={[
                        { required: true, message: "Please enter your mobile number!" },
                        {
                          pattern: /^[0-9]{10}$/,
                          message: "Mobile number must be exactly 10 digits!",
                        },
                      ]}
                    >
                      <Input placeholder="Mobile Number" maxLength={10} />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      label="Address Label"
                      name="address_label"
                      rules={[{ required: true, message: "Please enter your Address Label!" }]}
                    >
                      <Input placeholder="Address Label" />
                    </Form.Item>
                  </Col>
                </Row>
                
                <Form.Item>
                  <Button type="primary" className="checkoutButton" htmlType="submit">
                    Submit Address
                  </Button>
                </Form.Item>
              </Form>
            </Modal>
          </>
        );
      } else {
        // Guest user - Delivery
        if (userGuestAddresses.length > 0) {
          return (
            <>
              <div className="orderWelcomeSection commonSection">
                <div className="checkoutSectionMainWrap">
                  <div className="checkoutRightWrap">
                    <Title level={3} className="customHeading">
                      Choose Delivery Address
                    </Title>
                    
                    <div className="addAddressWrap" onClick={showGuestLoggedAddressModal}>
                      <svg width="24px" height="24px" viewBox="0 0 24 24" fill="#009de0">
                        <path d="M12 0C5.383 0 0 5.383 0 12s5.383 12 12 12 12-5.383 12-12S18.617 0 12 0zm5.25 13H13v4.25c0 .552-.448 1-1 1s-1-.448-1-1V13H6.75c-.552 0-1-.448-1-1s.448-1 1-1H11V6.75c0-.552.448-1 1-1s1 .448 1 1V11h4.25c.552 0 1 .448 1 1s-.448 1-1 1z"></path>
                      </svg>
                      Add New Address
                    </div>
                    
                    {/* Guest User's Address List for Delivery */}
                    {userGuestAddresses.length > 0 && (
                      <div className="checklistAddressList">
                        <Radio.Group
                          onChange={handleDeliveryAddressChange}
                          value={selectedDeliveryAddress}
                          className="addressRadioList"
                        >
                          <Row gutter={[8, 8]}>
                            {userGuestAddresses.map((address, index) => (
                              <Col xs={24} sm={12} key={address.id}>
                                <Radio key={address.id} value={address.id} style={{marginBottom:"10px"}}>
                                  <div className="addressWrap">
                                    <div className="addressDetails">
                                      <h5>
                                        <EnvironmentOutlined />
                                        {address.full_name}
                                      </h5>
                                      <p>{address.combine_address}</p>
                                      <p>{address.mobile_number}</p>
                                    </div>
                                    <Popconfirm
                                      title="Are you sure you want to delete this address?"
                                      onConfirm={() => handleGuestAddressDelete(address.id)}
                                      okText="Yes"
                                      cancelText="No"
                                    >
                                      <Button 
                                        type="text" 
                                        icon={<DeleteOutlined style={{ color: "red" }} />} 
                                      />
                                    </Popconfirm>
                                  </div>
                                </Radio>
                              </Col>
                            ))}
                          </Row>
                        </Radio.Group>
                      </div>
                    )}
                  </div>
                </div>
              </div>

              {/* Address Modal for Guest Users */}
              <Modal
                title="Add New Address"
                visible={isGuestLoggedAddressModalVisible}
                onCancel={handleGuestLoggedAddressCancel}
                maskClosable={false}
                footer={null}
              >
                {/* Map Viewer Start Here  */}
                <div style={{ position: "relative", height: "350px", width: "100%", marginBottom: "10px" }}>
                  <input id="pac-input" className="controls" type="text" placeholder="Search for places" />
                  <div id="map" style={{ height: "350px", width: "100%" }}></div>
                </div>
                {/*  Map Viewer End Here */}
                <Form layout="vertical" className="checkoutForm" form={Addressform} onFinish={handleGuestAddressSubmit}>
                  <ul id="addresses" style={{ display: "none" }}></ul>
                  <Form.Item name="latitude" hidden><Input /></Form.Item>
                  <Form.Item name="longitude" hidden><Input /></Form.Item>
                  <Form.Item name="country" hidden><Input /></Form.Item>

                  <Row gutter={16}>
                    <Col span={12} style={{ display: "none" }}>
                      <Form.Item
                        name="full_address"
                        label="Full Address"
                        rules={[{ required: true, message: "Please enter your Full Address!" }]}
                      >
                        <Input placeholder="Full Address" id="google_full_address" />
                      </Form.Item>
                    </Col>

                    <Col span={12}>
                      <Form.Item
                        label="House Number and Street"
                        name="house_number_street"
                        rules={[{ required: true, message: "Please enter your House Number and Street!" }]}
                      >
                        <Input placeholder="House Number and Street" id="house-number-street" />
                      </Form.Item>
                    </Col>

                    <Col span={12}>
                      <Form.Item
                        label="Town/City"
                        name="locality"
                        rules={[{ required: true, message: "Please enter your Town/City!" }]}
                      >
                        <Input placeholder="Town/City" id="locality" />
                      </Form.Item>
                    </Col>

                    <Col span={12}>
                      <Form.Item
                        label="Post Code"
                        name="zipcode"
                        rules={[{ required: true, message: "Please enter your Post Code!" }]}
                      >
                        <Input placeholder="Post Code" id="zipcode" />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item
                        label="Name"
                        name="full_name"
                        rules={[{ required: true, message: "Please enter your name!" }]}
                      >
                        <Input placeholder="Name" />
                      </Form.Item>
                    </Col>
                  </Row>

                  <Row gutter={16}>
                    <Col span={12}>
                      <Form.Item
                        label="Email Address"
                        name="email"
                        rules={[
                          { required: true, message: "Email is required!" },
                          { type: "email", message: "Please enter a valid email address!" },
                          {
                            pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                            message: "Email must be in the format: user@example.com",
                          },
                        ]}
                      >
                        <Input placeholder="Enter your email address" />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item
                        label="Mobile Number"
                        name="mobile_number"
                        rules={[
                          { required: true, message: "Please enter your mobile number!" },
                          {
                            pattern: /^[0-9]{10}$/,
                            message: "Mobile number must be exactly 10 digits!",
                          },
                        ]}
                      >
                        <Input placeholder="Mobile Number" maxLength={10} />
                      </Form.Item>
                    </Col>
                  </Row>

                  <Form.Item>
                    <Button type="primary" className="checkoutButton" htmlType="submit">
                      Submit Address
                    </Button>
                  </Form.Item>
                </Form>
              </Modal>
            </>
          );
        } else {
          // Guest user - No addresses - Show address form
          return (
            <div className="orderWelcomeSection commonSection">
              <div className="checkoutSectionMainWrap">
                <div className="checkoutRightWrap">
                  <Title level={3} className="customHeading" style={{ marginBottom: "20px" }}>
                    Billing Information
                  </Title>
                  <div style={{ position: "relative", height: "350px", width: "100%", marginBottom: "10px" }}>
                    <input id="pac-input" className="controls" type="text" placeholder="Search for places" />
                    <div id="map" style={{ height: "350px", width: "100%" }}></div>
                  </div>
                  <Form layout="vertical" className="checkoutForm" form={Addressform} onFinish={handleGuestAddressSubmit}>
                    <ul id="addresses" style={{ display: "none" }}></ul>
                    <Form.Item name="latitude" hidden><Input /></Form.Item>
                    <Form.Item name="longitude" hidden><Input /></Form.Item>
                    <Form.Item name="country" hidden><Input /></Form.Item>

                    <Row gutter={16}>
                      <Col span={12} style={{ display: "none" }}>
                        <Form.Item
                          name="full_address"
                          label="Full Address"
                          rules={[{ required: true, message: "Please enter your Full Address!" }]}
                        >
                          <Input placeholder="Full Address" id="google_full_address" />
                        </Form.Item>
                      </Col>

                      <Col span={12}>
                        <Form.Item
                          label="House Number and Street"
                          name="house_number_street"
                          rules={[{ required: true, message: "Please enter your House Number and Street!" }]}
                        >
                          <Input placeholder="House Number and Street" id="house-number-street" />
                        </Form.Item>
                      </Col>

                      <Col span={12}>
                        <Form.Item
                          label="Town/City"
                          name="locality"
                          rules={[{ required: true, message: "Please enter your Town/City!" }]}
                        >
                          <Input placeholder="Town/City" id="locality" />
                        </Form.Item>
                      </Col>

                      <Col span={12}>
                        <Form.Item
                          label="Post Code"
                          name="zipcode"
                          rules={[{ required: true, message: "Please enter your Post Code!" }]}
                        >
                          <Input placeholder="Post Code" id="zipcode" />
                        </Form.Item>
                      </Col>
                      <Col span={12}>
                        <Form.Item
                          label="Name"
                          name="full_name"
                          rules={[{ required: true, message: "Please enter your name!" }]}
                        >
                          <Input placeholder="Name" />
                        </Form.Item>
                      </Col>
                    </Row>

                    <Row gutter={16}>
                      <Col span={12}>
                        <Form.Item
                          label="Email Address"
                          name="email"
                          rules={[
                            { required: true, message: "Email is required!" },
                            { type: "email", message: "Please enter a valid email address!" },
                            {
                              pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                              message: "Email must be in the format: user@example.com",
                            },
                          ]}
                        >
                          <Input placeholder="Enter your email address" />
                        </Form.Item>
                      </Col>
                      <Col span={12}>
                        <Form.Item
                          label="Mobile Number"
                          name="mobile_number"
                          rules={[
                            { required: true, message: "Please enter your mobile number!" },
                            {
                              pattern: /^[0-9]{10}$/,
                              message: "Mobile number must be exactly 10 digits!",
                            },
                          ]}
                        >
                          <Input placeholder="Mobile Number" maxLength={10} />
                        </Form.Item>
                      </Col>
                    </Row>

                    <Form.Item>
                      <Button type="primary" className="checkoutButton" htmlType="submit">
                        Submit Address
                      </Button>
                    </Form.Item>
                  </Form>
                </div>
              </div>
            </div>
          );
        }
      }
    } else {
      // Collection orders
      if (userLoggedIn) {
        // Logged in user - Collection
        return (
          <div className="deliveryAddressSection commonSection">
            <div className="checkoutSectionMainWrap">
              <div className="checkoutRightWrap">
                <Title level={3} className="customHeading">
                  Your Information
                </Title>
                
                <div className="addressWrap">
                  <div className="addressDetails">
                    <h5>
                      <ShoppingOutlined />
                      Collection Order
                    </h5>
                    <p>Your account information will be used for this collection order.</p>
                    {!selectedDeliveryAddress && (
                      <Button type="primary" onClick={() => setSelectedDeliveryAddress("collection")}>
                        Confirm Collection
                      </Button>
                    )}
                    {selectedDeliveryAddress && (
                      <div style={{ color: '#52c41a', marginTop: '10px' }}>
                        ✓ Ready for collection
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      } else {
        // Guest user - Collection
        return (
          <div className="orderWelcomeSection commonSection">
            <div className="checkoutSectionMainWrap">
              <div className="checkoutRightWrap">
                <Title level={3} className="customHeading" style={{ marginBottom: "20px" }}>
                  Contact Information for Collection
                </Title>
                
                {!showCollectionInfoForm && !selectedDeliveryAddress && (
                  <div className="addAddressWrap" onClick={handleShowCollectionInfoForm}>
                    <svg width="24px" height="24px" viewBox="0 0 24 24" fill="#009de0">
                      <path d="M12 0C5.383 0 0 5.383 0 12s5.383 12 12 12 12-5.383 12-12S18.617 0 12 0zm5.25 13H13v4.25c0 .552-.448 1-1 1s-1-.448-1-1V13H6.75c-.552 0-1-.448-1-1s.448-1 1-1H11V6.75c0-.552.448-1 1-1s1 .448 1 1V11h4.25c.552 0 1 .448 1 1s-.448 1-1 1z"></path>
                    </svg>
                    Add Contact Information
                  </div>
                )}
                
                {(showCollectionInfoForm || selectedDeliveryAddress === "collection") && (
                  <div className="collectionInfoForm">
                    <Form layout="vertical" className="checkoutForm" form={Collectionform} onFinish={handleCollectionInfoSubmit}>
                      <Row gutter={16}>
                        <Col span={12}>
                          <Form.Item
                            label="Full Name"
                            name="full_name"
                            rules={[{ required: true, message: "Please enter your name!" }]}
                          >
                            <Input placeholder="Full Name" />
                          </Form.Item>
                        </Col>
                        <Col span={12}>
                          <Form.Item
                            label="Mobile Number"
                            name="mobile_number"
                            rules={[
                              { required: true, message: "Please enter your mobile number!" },
                              {
                                pattern: /^[0-9]{10}$/,
                                message: "Mobile number must be exactly 10 digits!",
                              },
                            ]}
                          >
                            <Input placeholder="Mobile Number" maxLength={10} />
                          </Form.Item>
                        </Col>
                      </Row>
                      <Row gutter={16}>
                        <Col span={24}>
                          <Form.Item
                            label="Email Address"
                            name="email"
                            rules={[
                              { required: true, message: "Email is required!" },
                              { type: "email", message: "Please enter a valid email address!" },
                            ]}
                          >
                            <Input placeholder="Enter your email address" />
                          </Form.Item>
                        </Col>
                      </Row>
                      <Form.Item>
                        <Button type="primary" className="checkoutButton" htmlType="submit">
                          Save Information
                        </Button>
                      </Form.Item>
                    </Form>
                  </div>
                )}
              </div>
            </div>
          </div>
        );
      }
    }
  };

  return (
    <div className="breadCrumbSection">
      <div className="custom_container">
        <Breadcrumb
          className="breadCrumbNav"
          items={[
            {
              href: "",
              title: (
                <>
                  <HomeOutlined />
                  <span>Home</span>
                </>
              ),
            },
            {
              title: "Checkout",
            },
          ]}
        />
        <div className="orderCheckoutSection">
          {cart.data.length > 0 ? (
            <Row gutter={[16, 16]}>
              <Col xs={24} lg={15} xl={15} xxl={15}>
                {renderOrderTypeContent()}

                {/* Payment Section Start Here */}
                {canProceedToPayment() && (
                  <div className="paymentSection commonSection">
                    <div className="checkoutSectionMainWrap">
                      <div className="checkoutRightWrap">
                        <Title level={3} className="customHeading">
                          Choose Payments
                        </Title>

                        {/* Payment Method Selection */}
                        <Radio.Group
                          onChange={handlePaymentMethodChange}
                          value={paymentMethod}
                          className="paymentMethodGroup"
                        >
                          {businessInfo?.businessInfo?.[0]?.portal_info?.[0]?.delivery_card_enable === 0 && orderType === 0 && (
                            <Radio value="credit">Pay by Credit/Debit Card</Radio>
                          )}
                          {businessInfo?.businessInfo?.[0]?.portal_info?.[0]?.delivery_cash_enable === 0 && orderType === 0 && (
                            <Radio value="cash">Pay by Cash</Radio>
                          )}
                          {businessInfo?.businessInfo?.[0]?.portal_info?.[0]?.pickup_card_enable === 0 && orderType === 1 && (
                            <Radio value="credit">Pay by Credit/Debit Card</Radio>
                          )}
                          {businessInfo?.businessInfo?.[0]?.portal_info?.[0]?.pickup_cash_enable === 0 && orderType === 1 && (
                            <Radio value="cash">Pay by Cash</Radio>
                          )}
                        </Radio.Group>

                        {/* Credit/Debit Card Form */}
                        {paymentMethod === "credit" && (
                          <div className="cardPaymentWrap">
                            <p className="cardGroupWrap">
                              <span className="cardImgHeading">We Accept</span>
                              <div className="cardGroup">
                                <a href="#"><img src={visacard} alt="Visa Card" /></a>
                                <a href="#"><img src={mastercard} alt="Master Card" /></a>
                                <a href="#"><img src={americancard} alt="American Express" /></a>
                                <a href="#"><img src={payoneercard} alt="Payoneer" /></a>
                                <a href="#"><img src={applepaycard} alt="Apple Pay" /></a>
                                <a href="#"><img src={banktransfercard} alt="Bank Transfer" /></a>
                                <a href="#"><img src={discovercard} alt="Discover" /></a>
                                <a href="#"><img src={jcbcard} alt="JCB" /></a>
                              </div>
                            </p>
                            <Row gutter={15} style={{marginBottom:"15px"}}>
                              <Col xs={24} sm={24} md={24}>
                                <p className="cardImgHeading">Credit/Debit Card</p>
                                <CardElement options={cardStyle} className="cardElement" />
                              </Col>
                            </Row>
                          </div>
                        )}

                        {/* Cash Payment Option */}
                        {paymentMethod === "cash" && (
                          <div className="cashPaymentWrap">
                            <p>You have selected to pay by Cash on {orderType === 0 ? "Delivery" : "Collection"}.</p>
                          </div>
                        )}

                        <Form name="layout-multiple-vertical" layout="vertical" className="checkoutForm">
                          <Row gutter={15}>
                            {/* Driver Tip Section */}
                            {orderType === 0 && ( 
                              <Col xs={24} sm={24} md={12}>
                                <Form.Item label="Rider Tips" name="driverTips" className="driverTipSection">
                                  <InputNumber
                                    min={0}
                                    max={100}
                                    step={1}
                                    placeholder="Enter Rider Tip (£)"
                                    value={driverTips}
                                    onChange={handleDriverTipChange}
                                    size="large"
                                  />
                                </Form.Item>
                              </Col>
                            )}

                            {/* Special Instructions Section */}
                            <Col xs={24} sm={24} md={24}>
                              <Form.Item label="Special Comment" name="specialComment" className="specialCommentSection">
                                <TextArea
                                  id="specialComment"
                                  value={specialComment}
                                  onChange={handleSpecialCommentChange}
                                  placeholder="Enter special comment"
                                  rows={4}
                                />
                              </Form.Item>
                            </Col>
                          </Row>
                        </Form>
                        
                        {error && <p className="error">{error}</p>}
                        
                        {/* Checkout Button */}
                        {orderType === 0 && subtotal > businessInfo?.businessInfo?.[0]?.charge_info?.[0]?.min_delivery_order && (
                          <Button
                            type="primary"
                            className="checkoutButton"
                            onClick={handlePlaceOrder}
                            disabled={processing}
                            loading={processing}
                          >
                            {paymentMethod === 'credit' ? 'Pay Now' : 'Place Order'} &pound;{grandTotal.toFixed(2)} <ArrowRightOutlined />
                          </Button>
                        )}

                        {orderType === 1 && subtotal > businessInfo?.businessInfo?.[0]?.charge_info?.[0]?.min_pickup_order && (
                          <Button
                            type="primary"
                            className="checkoutButton"
                            disabled={processing}
                            onClick={handlePlaceOrder}
                            loading={processing}
                          >
                            {paymentMethod === 'credit' ? 'Pay Now' : 'Place Order'} &pound;{grandTotal.toFixed(2)} <ArrowRightOutlined />
                          </Button>
                        )}
                      </div>
                    </div>
                  </div>
                )}
              </Col>

              {/* Right Column - Cart Summary */}
              <Col xs={24} lg={9} xl={9} xxl={9}>
                <div className="checkoutCartSection commonSection sticky-cart-mobile">
                  <Title level={3} className="customHeading">
                    Cart Summary
                  </Title>
                  <div className="cartContainer">
                    {/* Cart items list */}
                    <div className="cartWrap">
                      <div className="cartListItem">
                        <List
                          locale={{ emptyText: <CustomEmpty /> }}
                          dataSource={cart.data || []}
                          renderItem={(item) => (
                            <List.Item key={item.id}>
                              <div className="headercartItemContainer">
                                <div className="headercartItemDetails">
                                  <div className="headercartItemName">
                                    {item.quantity} x {item.food_items.food_item_name_en}
                                  </div>
                                  <div className="headercartItemSize">
                                    {item.master_size ? (
                                      <span>
                                        + {item.master_size.food_item_size_name_en}{" "}
                                        <span>(&pound;{(getItemBasePrice(item) * item.quantity).toFixed(2)})</span>
                                      </span>
                                    ) : (
                                      <span>(&pound;{(getItemBasePrice(item) * item.quantity).toFixed(2)})</span>
                                    )}
                                  </div>
                                  {item.extra_addons?.length > 0 && (
                                    <div className="headercartItemExtras">
                                      {item.extra_addons.map((addon) => (
                                        <span key={addon.id}>
                                          + {addon.name} ({addon.quantity} x &pound;{addon.addon_price.toFixed(2)})
                                        </span>
                                      ))}
                                    </div>
                                  )}
                                </div>

                                <div className="headercartInputQtyWrap">
                                  <Row align="middle" justify="space-between">
                                    <div className="headercartQuantityControls">
                                      <Button type="default" className="headercartMinusBtn" icon={Cartloading ? (<Spin size="small" />) : ("")} onClick={() => handleUpdateItem(item.id, item.quantity - 1)} disabled={Cartloading}> - </Button>
                                      <div className="headercartInputQty">{item.quantity}</div>
                                      <Button type="default" className="headercartPlusBtn" icon={Cartloading ? (<Spin size="small" />) : ("")} onClick={() => handleUpdateItem(item.id, item.quantity + 1)} disabled={Cartloading}> + </Button>
                                    </div>
                                    <div className="headercartItemPricedetails">&pound;{getItemTotal(item).toFixed(2)}</div>
                                  </Row>
                                </div>
                              </div>
                            </List.Item>
                          )}
                        />
                      </div>
                    </div>

                    {/* Order type selection and bill summary */}
                    {cart.data.length > 0 && (
                      <>
                        <div className="headerCartOrderType applyCuponWrap">
                          <Title level={4} className="billHead">Choose Order Type</Title>
                          <Radio.Group
                            value={String(orderType)}
                            onChange={(e) => handleUpdateOrderType(e.target.value)}
                            buttonStyle="solid"
                            className="customRadioGroup"
                          >
                            {businessInfo?.businessInfo?.[0]?.portal_info?.[0]?.pickup_type_enable === 0 && (
                              <Radio.Button value="1" className="radioButton">
                                <div className="radioContent">
                                  <svg viewBox="0 0 24 24" height="40" fill="currentColor">
                                    <path
                                      fillRule="evenodd"
                                      clipRule="evenodd"
                                      d="M13.869 3.284a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Zm2.109 9.162a8.519 8.519 0 0 1-2.418-1.266l-.288-.218a.25.25 0 0 0-.4.200v1.804a.993.993 0 0 0 .355.754 17.2 17.2 0 0 1 4.568 7.518 1.5 1.5 0 1 1-2.846.952 16.622 16.622 0 0 0-2.416-4.927.25.25 0 0 0-.433.081 17.332 17.332 0 0 1-2.56 5.309 1.5 1.5 0 1 1-2.344-1.873 12.745 12.745 0 0 0 2.213-4.7c.308-1.385.463-2.799.463-4.217v-1.357a.25.25 0 0 0-.38-.214 3.413 3.413 0 0 0-1.622 2.944 1.5 1.5 0 0 1-1.5 1.426 1.5 1.5 0 0 1-1.5-1.613 6.32 6.32 0 0 1 3.511-5.571 5.7 5.7 0 0 1 5.963.54l1.016.762a5.514 5.514 0 0 0 1.564.820l1.105.367a1.551 1.551 0 0 1 1.083 1.673 1.5 1.5 0 0 1-1.958 1.198l-1.176-.392Z"
                                    ></path>
                                  </svg>
                                  <span>{businessInfo?.businessInfo?.[0]?.homelng?.[0]?.collection_en ?? "Collection"}</span>
                                  <span>{businessInfo?.businessInfo?.[0]?.portal_info?.[0]?.pickup_estimate_time}min Approx</span>
                                </div>
                              </Radio.Button>
                            )}
                            {businessInfo?.businessInfo?.[0]?.portal_info?.[0]?.delivery_type_enable === 0 && (
                              <Radio.Button value="0" className="radioButton">
                                <div className="radioContent">
                                  <svg viewBox="0 0 24 24" height="40" fill="currentColor">
                                    <path
                                      fillRule="evenodd"
                                      clipRule="evenodd"
                                      d="M4.401 9.602c.281.281.666.439 1.062.439h.039a1.48 1.48 0 0 0 1.075-.496l3.157-3.507a1.505 1.505 0 0 0-.055-2.071L8.098 2.385A1.547 1.547 0 0 0 7 1.947c-.41.01-.802.191-1.076.495l-3.16 3.512a1.502 1.502 0 0 0 .054 2.066l1.583 1.582Zm6.321 2.132 1.451-1.659a8.276 8.276 0 0 0 4.655 1.420h.672a1.5 1.5 0 1 0 0-3h-.672a5.363 5.363 0 0 1-3.767-1.561 1.407 1.407 0 0 0-1.111-.438 1.5 1.5 0 0 0-1.079.511l-3.5 4a1.5 1.5 0 0 0 .300 2.236l.664.442a5.261 5.261 0 0 1 2.200 5.484 1.5 1.5 0 1 0 2.928.651 8.285 8.285 0 0 0-2.741-8.086ZM22 18.495a2.5 2.5 0 1 0-5 0 2.5 2.5 0 0 0 5 0Zm2 0a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-17 0a2.5 2.5 0 1 0-5 0 2.5 2.5 0 0 0 5 0Zm2 0a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm3.125-14.5a2.375 2.375 0 1 1 4.75 0 2.375 2.375 0 0 1-4.75 0Z"
                                    ></path>
                                  </svg>
                                  <span>{businessInfo?.businessInfo?.[0]?.homelng?.[0]?.delivery_en ?? "Delivery"}</span>
                                  <span>{businessInfo?.businessInfo?.[0]?.portal_info?.[0]?.delivery_estimate_time}min Approx</span>
                                </div>
                              </Radio.Button>
                            )}
                          </Radio.Group>
                        </div>

                        {couponDiscount <= 0 && (
                          <div className="applyCuponWrap">
                            <Space.Compact style={{ width: "100%" }}>
                              <Input placeholder="Enter promo code" value={CouponCode} onChange={handleCouponCodeChange} />
                              <Button type="primary" icon={Cartloading ? (<Spin size="small" />) : ("")} disabled={Cartloading} onClick={handleCouponCode}>
                                <svg width="40px" height="40px" viewBox="0 0 38 39" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  {/* Your SVG code */}
                                </svg>
                                Apply
                              </Button>
                            </Space.Compact>
                          </div>
                        )}

                        {/* Bill Summary */}
                        <div className="applyCuponWrap">
                          {orderType === 0 && subtotal < businessInfo?.businessInfo?.[0]?.charge_info?.[0]?.min_delivery_order && (
                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: '#ffe6e6', padding: '10px', marginBottom: '10px', borderRadius: '4px' }}>
                              <Title level={4} style={{ margin: 0 }}>
                                The minimum order value is &pound;{businessInfo?.businessInfo?.[0]?.charge_info?.[0]?.min_delivery_order}
                              </Title>
                            </div>
                          )}

                          {orderType === 1 && subtotal < businessInfo?.businessInfo?.[0]?.charge_info?.[0]?.min_pickup_order && (
                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: '#ffe6e6', padding: '10px', marginBottom: '10px', borderRadius: '4px' }}>
                              <Title level={4} style={{ margin: 0 }}>
                                The minimum order value is &pound;{businessInfo?.businessInfo?.[0]?.charge_info?.[0]?.min_pickup_order}
                              </Title>
                            </div>
                          )}

                          <Title level={4} className="billHead">Bill Summary</Title>
                          <div className="billSummary">
                            <div className="billItemWrap">
                              <div className="billItemTitle">Sub Total</div>
                              <div className="billItemValue">&pound;{subtotal.toFixed(2)}</div>
                            </div>
                            {orderType === 0 && calculatedDeliveryCharge > 0 && (
                              <div className="billItemWrap">
                                <div className="billItemTitle">Delivery Fee</div>
                                <div className="billItemValue">&pound;{calculatedDeliveryCharge.toFixed(2)}</div>
                              </div>
                            )}
                            {packageFee > 0 && businessInfo?.businessInfo?.[0]?.charge_info?.[0]?.packaging_charge_enable === 1 && (
                              <div className="billItemWrap">
                                <div className="billItemTitle">Service Fee</div>
                                <div className="billItemValue">&pound;{packageFee.toFixed(2)}</div>
                              </div>
                            )}
                            {orderType === 0 && driverTips > 0 && (
                              <div className="billItemWrap">
                                <div className="billItemTitle">Rider Tip Amount</div>
                                <div className="billItemValue">&pound;{driverTips.toFixed(2)}</div>
                              </div>
                            )}
                            {couponDiscount > 0 && (
                              <div className="billItemWrap">
                                <div className="billItemTitle">Coupon Discount Amount</div>
                                <div className="billItemValue">&pound;{couponDiscount.toFixed(2)}</div>
                              </div>
                            )}
                            {discount > 0 && (
                              <div className="billItemWrap">
                                <div className="billItemTitle">Direct Discount Amount</div>
                                <div className="billItemValue">&pound;{discount.toFixed(2)}</div>
                              </div>
                            )}
                            <div className="billItemWrap">
                              <div className="billItemTitle">Grand Total</div>
                              <div className="billItemValue">&pound;{grandTotal.toFixed(2)}</div>
                            </div>
                            {totalSavings > 0 && (
                              <div className="billTotalDiscountWrap">
                                <div className="billTotalDiscountTitle">Your Total Direct Order Savings</div>
                                <div className="billTotalDiscountValue">&pound;{totalSavings.toFixed(2)}</div>
                              </div>
                            )}
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </Col>
            </Row>
          ) : (
            <CustomEmpty />
          )}
        </div>
      </div>
    </div>
  );
};

export default Checkout;